// extracted by mini-css-extract-plugin
export default {"labelTd":"ThongTinDonvi_labelTd__7yES9","tr":"ThongTinDonvi_tr__H0skD"};